/**
 * Manages runtime (virtual) rules from footprint assets or other runtime
 * sources.
 *
 * The data is expected to be eventually stored in the documentService
 *
 * QUESTION: should we rename runtime rules to virtual rules everywhere in
 * recognition of tight coupling?
 */
export class PcbLayoutRuntimeRulesManager {
    runtimePcbLayoutRules = {};
    deleteRuntimePcbLayoutRulesFromAncestor(nodeData) {
        const rulesToRemove = [];
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(this.runtimePcbLayoutRules).forEach((rule) => {
            if (rule.generatedFromAncestorNodeUid === nodeData.uid) {
                this.deleteRuntimePcbLayoutRule(rule.uid);
                rulesToRemove.push(rule.uid);
            }
        });
        return rulesToRemove;
    }
    // NOTE: this is an N^2 loop with N(ruleset) * N(runtimePcbLayoutRules)
    addRuntimePcbLayoutRules(ruleSets) {
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        Object.values(ruleSets).forEach((ruleset) => {
            if (!this.findEqualRuleSet(ruleset)) {
                this.updateRuntimePcbLayoutRule(ruleset.uid, ruleset);
            }
        });
    }
    updateRuntimePcbLayoutRule(ruleUid, rule) {
        this.runtimePcbLayoutRules[ruleUid] = rule;
    }
    deleteRuntimePcbLayoutRule(ruleUid) {
        delete this.runtimePcbLayoutRules[ruleUid];
    }
    findEqualRuleSet(ruleset) {
        return Object.values(this.runtimePcbLayoutRules).find((existingRuleSet) => this.isEqualRuleSet(existingRuleSet, ruleset));
    }
    isEqualRuleSet(existingRule, ruleset) {
        return (existingRule.selector === ruleset.selector &&
            existingRule.generatedFromAncestorNodeUid === ruleset.generatedFromAncestorNodeUid);
    }
}
//# sourceMappingURL=PcbLayoutRuntimeRulesManager.js.map